// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1667":"3d8f4742","7072":"16c65441","7765":"3d8f4742","8998":"3d8f4742","9726":"3d8f4742"}[chunkId] + ".chunk.css";
};